import React from 'react';
import { useUser } from '../../../context/UserContext';
import { GROUPS, SECTION_BY_ID, isViewOnly } from '../../../utils/staffCapabilities';
import { useAdminShell } from './AdminShellContext';
import { ReadOnlyLine, RingLine } from './ui';

/**
 * Every section's hero — the black #0A0A0A card with the ring-gradient hairline along
 * the top. Eyebrow from the group, the section title, one meta sentence, the view-only
 * line when it applies, and the gated action pills (use `variant="white"` for the
 * primary and `variant="quiet"` for the rest — a black `solid` pill vanishes here).
 */
export default function AdminPageHeader({ section, title, meta, actions, eyebrowTail, viewOnly, children }) {
  const { staff } = useUser();
  const { isMobile } = useAdminShell();
  const def = SECTION_BY_ID[section];
  const group = def ? GROUPS.find((g) => g.key === def.group) : null;
  const tail = eyebrowTail ?? (group && group.key !== 'now' ? group.label : null);
  const showViewOnly = viewOnly ?? (def?.cap ? isViewOnly(staff, def.cap) : false);
  return (
    <header className={`relative flex flex-wrap items-end justify-between gap-x-5 gap-y-4 overflow-hidden rounded-[28px] bg-[#0A0A0A] text-white ${isMobile ? 'px-5 py-[22px]' : 'px-[30px] py-7'}`}>
      <RingLine />
      <div className="flex min-w-0 flex-1 basis-[340px] flex-col gap-[10px]">
        <span className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-[#8A8A8A]">PORTAL · STAFF{tail ? ` · ${tail}` : ''}</span>
        <h1 className={`m-0 font-mono font-bold uppercase leading-none tracking-[0.04em] ${isMobile ? 'text-[26px]' : 'text-[34px]'}`}>{title ?? def?.label}</h1>
        {meta && <p className="m-0 max-w-[640px] font-mono text-[12px] leading-[1.6] text-[#BDBDBD]">{meta}</p>}
        {showViewOnly && <ReadOnlyLine />}
      </div>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
      {children}
    </header>
  );
}
